export const isNonEmptyArray = (array: unknown): array is unknown[] => {
    return Array.isArray(array) && array.length > 0;
};
export const isStringifiedArray = (value: unknown): value is string => {
    if (typeof value !== 'string' || !value.trim()) {
        return false;
    }

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed); // valid JSON and it's an array
    } catch {
        return false; // not valid JSON
    }
};
